<template>
  <div :style="{width: '300px'}"
       data-dusk="notes-filter-dropdown">
    <dd-card>
      <div class="flex-col gap-y-sm">
        <dd-input
            title="Onderwerp"
            :value="filter.title"
            :lazy="true"
            @input="(val) => updateFilterKeyValue('title', val)"
            placeholder="Onderwerp..."
            v-on:click.stop
            data-dusk="dropdown-note-title"
        ></dd-input>

        <dd-date-range-picker
            title="Periode"
            :value="filter.dateRange"
            :default-picker-value="[moment().subtract(1, 'months'), moment()]"
            :placeholder="['Startdatum', 'Einddatum']"
            :ranges="{
            'Vorige maand': [
              moment().subtract(1, 'months').startOf('month'),
              moment().subtract(1, 'months').endOf('month')
            ],
            'Deze maand': [
              moment().startOf('month'),
              moment().endOf('month')
            ]}"
            @input="(val) => updateFilterKeyValue('dateRange', val)"
            data-dusk="dropdown-date-range"
        >
          <a-icon slot="suffixIcon" type="calendar"/>
        </dd-date-range-picker>

        <dd-input-wrapper title="Gebruiker(s)">
          <users-select
              :value="filter.createdByUser"
              @change="(val) => updateFilterKeyValue('createdByUser', val)"
              data-dusk="dropdown-created-by-user"
              appendCssClass="small"
              style="display: inline-block; min-width: 160px;"
          />
        </dd-input-wrapper>

        <dd-select
            title="Zichtbaar voor klant"
            v-model="filter.visibleForCustomer"
            @input="(val) => updateFilterKeyValue('visibleForCustomer', val)"
            v-on:click.stop
            :allowClear="true"
            name="visible-for-customer"
            id="visible-for-customer-select"
            data-dusk="dropdown-visible-for-customer"
            style="min-width: 135px;"
        >
          <a-select-option value="0">
            Niet gepubliceerd
          </a-select-option>
          <a-select-option value="1">
            Gepubliceerd
          </a-select-option>
        </dd-select>

        <div class="flex-row justify-content-end align-items-center gap-sm">
          <dd-button @click="clearAll" :outline="true" :small="true">
            Wis filters
          </dd-button>
          <dd-button @click="$emit('close')" :small="true">
            Klaar
          </dd-button>
        </div>
      </div>

    </dd-card>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL';
import moment from 'moment';
import DateFormatEnum from '../../../enums/DateFormatEnum';
export default {
  name: "NotesFilterDropdown",
  emits: ['input', 'close'],
  props: {
    value: {
      type: Object,
      required: false,
      default: {
        childName: null,
        dateRange: [],
        createdByUser: null,
        visibleForCustomer: null,
      },
    }
  },
  data() {
    return {
      locale,
      filter: this.value,
    }
  },
  watch: {
    value(value) {
      this.filter = value;
    }
  },
  methods: {
    moment,
    updateFilterKeyValue(key, value) {
      let filter = {
        ...this.value,
        [key]: value,
      }
      this.filterRequest(filter);
    },
    filterRequest(filter) {
      this.$emit('input', filter);
    },
    clearAll() {
      this.filter = {};
      this.filterRequest(this.filter);
      this.$emit('close');
    },
  },
}
</script>

<style scoped>
.table-head > tr > th {
  background-color: transparent;
}

.table-body > tr > td {
  border-top: 0;
}
</style>
